import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const translations = {
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.projects": "Projects",
    "nav.certifications": "Certificates",
    "nav.resume": "Resume",
    "nav.github": "GitHub",
    "nav.contact": "Let’s talk",
    "brand.role": "Mobile & web engineer",
    "hero.available": "Available for selected projects",
    "hero.intro": "Hello, I’m Zainal Salamun",
    "hero.title": "I build digital products that feel",
    "hero.emphasis": "fast, useful, and human.",
    "hero.focus": "Focused on",
    "hero.summary":
      "Jakarta-based software engineer with 9+ years of experience turning complex ideas into reliable mobile and web products.",
    "hero.work": "Explore my work",
    "hero.resume": "View résumé",
    "hero.years": "Years building",
    "hero.projects": "Projects shipped",
    "hero.platforms": "Core platforms",
    "hero.engineer": "01 / ENGINEER",
    "home.aboutLabel": "A little about me",
    "home.aboutTitle": "Engineering craft, shaped by",
    "home.aboutEmphasis": "product thinking.",
    "home.aboutBody":
      "I enjoy the space where thoughtful UX meets dependable engineering. My work spans native Android, Flutter, React, and backend services—always with an eye on maintainability, performance, and real user needs.",
    "home.aboutLink": "More about my approach →",
    "home.location": "Based in Jakarta, Indonesia",
    "home.socialLabel": "Elsewhere on the internet",
    "home.socialTitle": "Let’s stay connected.",
    "about.title": "Know Who",
    "about.me": "I Am",
    "about.skills": "Professional Skillset",
    "about.tools": "Tools I Use",
    "about.code": "Days I Code",
    "about.github": "View my GitHub profile",
    "about.githubActivity": "Live GitHub activity",
    "about.contributions": "{{count}} contributions in the last year",
    "about.currentFocusLabel": "Current focus",
    "about.currentFocusTitle": "Building resilient mobile products.",
    "about.currentFocusBody":
      "I’m currently focused on scalable Flutter and Android applications with clean architecture, dependable offline experiences, and thoughtful AI integrations.",
    "about.githubSelected": "Selected on GitHub",
    "about.featuredRepos": "Featured repositories",
    "about.featuredReposBody":
      "A closer look at projects that represent my approach to product engineering, architecture, and user experience.",
    "about.openSource": "Open source",
    "about.viewRepository": "View repository",
    "experience.eyebrow": "Professional journey",
    "experience.title": "Work experience",
    "experience.subtitle":
      "Nine years of building and maintaining mobile products across fintech, field operations, HR, community platforms, and healthcare.",
    "experience.publishedApps": "Hospital reservation portfolio",
    "certifications.eyebrow": "Continuous learning",
    "certifications.title": "Certifications",
    "certifications.subtitle":
      "A verified learning journey across mobile, web, AI, cloud, product management, and software architecture.",
    "certifications.issued": "Issued",
    "certifications.credential": "Credential ID",
    "certifications.credentials": "credentials",
    "certifications.issuers": "issuers",
    "certifications.item": "certificate",
    "certifications.items": "certificates",
    "certifications.summaryLabel": "Certification summary",
    "certifications.viewCredential": "View credential",
    "certifications.viewLinkedIn": "View all on LinkedIn",
    "about.greeting": "Hi, I’m",
    "about.identity": "a mobile developer based in",
    "about.currentPrefix": "I currently work as an",
    "about.currentRole": "Assistant Manager – Mobile Developer at Yokke",
    "about.currentSuffix":
      "where I develop and maintain Flutter applications that support inventory management and field operations.",
    "about.education":
      "I hold a Bachelor’s degree in Informatics from Universitas Teknologi Digital Indonesia, formerly known as STMIK Akakom.",
    "about.experience":
      "With more than nine years of experience in mobile application development, I specialize in Android and Flutter, supported by a strong foundation in object-oriented programming, problem-solving, and product thinking. I have worked across the complete application lifecycle—from translating product requirements and UI designs into working features to API integration, testing, deployment, and long-term maintenance.",
    "about.architecture":
      "I enjoy applying SOLID principles, Clean Architecture, and scalable state management to create codebases that are easier to understand and maintain. I can build applications from the ground up or improve existing architectures, including systems that require offline-first data handling, background synchronization, location services, and native device integrations.",
    "about.activities": "Beyond coding, I enjoy:",
    "about.sports": "Futsal, football, and running",
    "about.reading": "Reading books",
    "about.travel": "Travelling",
    "projects.title": "My Recent",
    "projects.emphasis": "Work",
    "projects.subtitle": "Here are a few projects I’ve worked on recently.",
    "projects.eyebrow": "Selected work",
    "projects.source": "Source",
    "projects.demo": "Demo",
    "resume.download": "Download CV",
    "resume.previous": "Previous",
    "resume.next": "Next",
    "resume.page": "Page",
    "resume.of": "of",
    "footer.craft": "Designed & built with care",
    "github.eyebrow": "GitHub portfolio",
    "github.title": "Code, collaboration &",
    "github.emphasis": "open source.",
    "github.subtitle":
      "Selected repositories and a live view of the work I publish, explore, and improve on GitHub.",
  },
  id: {
    "nav.home": "Beranda",
    "nav.about": "Tentang",
    "nav.projects": "Proyek",
    "nav.certifications": "Sertifikat",
    "nav.resume": "Resume",
    "nav.github": "GitHub",
    "nav.contact": "Mari bicara",
    "brand.role": "Engineer mobile & web",
    "hero.available": "Tersedia untuk proyek terpilih",
    "hero.intro": "Halo, saya Zainal Salamun",
    "hero.title": "Saya membangun produk digital yang terasa",
    "hero.emphasis": "cepat, berguna, dan manusiawi.",
    "hero.focus": "Berfokus pada",
    "hero.summary":
      "Software engineer berbasis di Jakarta dengan pengalaman 9+ tahun mengubah ide kompleks menjadi produk mobile dan web yang andal.",
    "hero.work": "Lihat karya saya",
    "hero.resume": "Lihat résumé",
    "hero.years": "Tahun berkarya",
    "hero.projects": "Proyek dirilis",
    "hero.platforms": "Platform utama",
    "hero.engineer": "01 / ENGINEER",
    "home.aboutLabel": "Sedikit tentang saya",
    "home.aboutTitle": "Keahlian engineering, dipadukan dengan",
    "home.aboutEmphasis": "cara berpikir produk.",
    "home.aboutBody":
      "Saya menyukai titik temu antara UX yang matang dan engineering yang andal. Pekerjaan saya mencakup Android native, Flutter, React, dan layanan backend—dengan perhatian pada kemudahan pemeliharaan, performa, dan kebutuhan nyata pengguna.",
    "home.aboutLink": "Selengkapnya tentang pendekatan saya →",
    "home.location": "Berbasis di Jakarta, Indonesia",
    "home.socialLabel": "Temukan saya di internet",
    "home.socialTitle": "Mari tetap terhubung.",
    "about.title": "Kenali Siapa",
    "about.me": "Saya",
    "about.skills": "Keahlian Profesional",
    "about.tools": "Tools yang Saya Gunakan",
    "about.code": "Hari Saya Menulis Kode",
    "about.github": "Lihat profil GitHub saya",
    "about.githubActivity": "Aktivitas GitHub otomatis",
    "about.contributions": "{{count}} kontribusi dalam setahun terakhir",
    "about.currentFocusLabel": "Fokus saat ini",
    "about.currentFocusTitle": "Membangun produk mobile yang tangguh.",
    "about.currentFocusBody":
      "Saat ini saya berfokus pada aplikasi Flutter dan Android yang skalabel dengan clean architecture, pengalaman offline yang andal, dan integrasi AI yang tepat guna.",
    "about.githubSelected": "Pilihan di GitHub",
    "about.featuredRepos": "Repository unggulan",
    "about.featuredReposBody":
      "Pilihan project yang mewakili pendekatan saya terhadap product engineering, arsitektur, dan pengalaman pengguna.",
    "about.openSource": "Open source",
    "about.viewRepository": "Lihat repository",
    "experience.eyebrow": "Perjalanan profesional",
    "experience.title": "Pengalaman kerja",
    "experience.subtitle":
      "Sembilan tahun membangun dan memelihara produk mobile untuk fintech, operasional lapangan, HR, platform komunitas, dan layanan kesehatan.",
    "experience.publishedApps": "Portofolio aplikasi reservasi rumah sakit",
    "certifications.eyebrow": "Pembelajaran berkelanjutan",
    "certifications.title": "Sertifikasi",
    "certifications.subtitle":
      "Perjalanan belajar terverifikasi di bidang mobile, web, AI, cloud, product management, dan arsitektur perangkat lunak.",
    "certifications.issued": "Diterbitkan",
    "certifications.credential": "ID kredensial",
    "certifications.credentials": "kredensial",
    "certifications.issuers": "penerbit",
    "certifications.item": "sertifikat",
    "certifications.items": "sertifikat",
    "certifications.summaryLabel": "Ringkasan sertifikasi",
    "certifications.viewCredential": "Lihat kredensial",
    "certifications.viewLinkedIn": "Lihat semua di LinkedIn",
    "about.greeting": "Halo, saya",
    "about.identity": "seorang mobile developer yang berbasis di",
    "about.currentPrefix": "Saat ini saya bekerja sebagai",
    "about.currentRole": "Assistant Manager – Mobile Developer di Yokke",
    "about.currentSuffix":
      "dan mengembangkan serta memelihara aplikasi Flutter untuk mendukung manajemen inventaris dan operasional lapangan.",
    "about.education":
      "Saya meraih gelar Sarjana Informatika dari Universitas Teknologi Digital Indonesia, sebelumnya dikenal sebagai STMIK Akakom.",
    "about.experience":
      "Dengan pengalaman lebih dari sembilan tahun dalam pengembangan aplikasi mobile, saya berfokus pada Android dan Flutter serta memiliki fondasi kuat dalam object-oriented programming, problem-solving, dan product thinking. Pengalaman saya mencakup seluruh siklus pengembangan aplikasi, mulai dari menerjemahkan kebutuhan produk dan desain UI menjadi fitur, integrasi API, pengujian, deployment, hingga pemeliharaan jangka panjang.",
    "about.architecture":
      "Saya menerapkan prinsip SOLID, Clean Architecture, dan state management yang skalabel untuk menghasilkan codebase yang mudah dipahami dan dipelihara. Saya mampu membangun aplikasi dari awal maupun meningkatkan arsitektur yang sudah ada, termasuk sistem dengan offline-first data handling, background synchronization, location services, dan integrasi perangkat native.",
    "about.activities": "Di luar coding, saya menikmati:",
    "about.sports": "Futsal, sepak bola, dan lari",
    "about.reading": "Membaca buku",
    "about.travel": "Bepergian",
    "projects.title": "Karya",
    "projects.emphasis": "Terbaru",
    "projects.subtitle": "Berikut beberapa proyek yang baru-baru ini saya kerjakan.",
    "projects.eyebrow": "Karya pilihan",
    "projects.source": "Kode",
    "projects.demo": "Demo",
    "resume.download": "Unduh CV",
    "resume.previous": "Sebelumnya",
    "resume.next": "Berikutnya",
    "resume.page": "Halaman",
    "resume.of": "dari",
    "footer.craft": "Didesain & dibangun dengan sepenuh hati",
    "github.eyebrow": "Portofolio GitHub",
    "github.title": "Kode, kolaborasi &",
    "github.emphasis": "open source.",
    "github.subtitle":
      "Repository pilihan dan aktivitas terbaru dari karya yang saya publikasikan, eksplorasi, dan kembangkan di GitHub.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const savedLanguage = window.localStorage.getItem("portfolio-language");
    return savedLanguage === "id" ? "id" : "en";
  });

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = (nextLanguage) => {
    const languageToUse = nextLanguage === "id" ? "id" : "en";
    window.localStorage.setItem("portfolio-language", languageToUse);
    setLanguageState(languageToUse);
  };

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      t: (key) => translations[language][key] || translations.en[key] || key,
    }),
    [language]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
